//AllTableClasses.ts
export class BaseReturn {
  Success?: boolean;
  Data: any;
  UserErrorMessage?: string;
  ID?: number;
  InformationMessage?: string;
}

export class Login_Model {
  public UserName!: string;
  public Password!: string;
  public Email!: string;
  public RememberMe!: boolean;
  public hdrandomSeed!: string;
  public guid!: string;
  public Url!: string;
  public SysproCompanyID!: number;
}

export class User_Credentials {
  public UserName!: string;
  public Password!: string;
}

export class User_Login {
  public UserID!: number;
  public UserName!: string;
  public UserGuid!: string;
  public Password!: string;
  public RememberMe!: boolean;
}

export class User_PasswordAdmin {
  public Guid!: string;
  public UserName!: string;
  public Email!: string;
  public Password!: string;
}

export class PasswordResetRequest {
  public UserGuid!: string;
  public UserCellphone!: string;
  public UserName!: string;
  public Password!: string;
  public GuidGeneratedForUser!: string;
  public MessageFormat!: string;
}

export class MenuItems{
  public Name!: string;
  public Description!: string;
  public IsDropDown!: boolean;
  public ParentMenu!: string;
  public Url!: string;
  public Class!: string;
}

export class Admin_SysproCompanyLookup {
  public ID!: number;
  public Guid!: string;
  public CreateDate!: string;
  public CreateAgentID!: number;
  public UpdateDate!: string;
  public UpdateAgentID!: number;
  public Active!: boolean;
  public timestamp!: number;
  public SysproCompany!: string;
  public CRMCompany!: string;
  public Description!: string;
  public WarehouseLatitude!: string;
  public WarehouseLongitude!: string;
  public SysproURL!: string;
  public CompanyUser!: string;
  public UserPass!: string;
  public LoginCompany!: string;
  public CompanyPass!: string;
  public UnitSystem!: string;
  public CompanyCurrency!: string;
  public CenterLatitude!: string;
  public CenterLongitude!: string;
  public Instance!: string;
}

export class Client {
  public SysproCompanyID!: number;
  public CRMCompany!: string;
  public AllowShopping!: boolean;
  public Supplier!: string;
}

export class FunctionItems {
  public New: string = 'New';
  public FullDATA: string = 'FullDATA';
  public Override: string = 'Override';
  public ImagesOnly: string = 'Images Only';
}

export class UOMItems {
  public Each: string = 'Each';
  public Box: string = 'Box';
}
export class PopupModel {

  public Data?: any;
  public Label?: string;
  public Title?: string;
  public Message?: string;
  public MessageType?: 'success' | 'error' | 'warning' | 'info';
  public Display: boolean = true;
  public Button: PopupButton = new PopupButton();
  public AltButton?: PopupButton = new PopupButton();

}

export class PopupSetupModel {
  public Data?: any;
  public Label?: string;
  public Title?: string;
  public Message?: string;
  public PopupAction?: string;
  public Display: boolean = true;
  public Button: PopupButton = new PopupButton();
  public AltButton?: PopupButton = new PopupButton();

}

export class PopupModelReturn {
  public Result?: string;
  public Data?: any;

}

export class EmailPopupModel {
  public Title?: string;
  public Message?: string;
  public MessageType?: 'success' | 'error' | 'warning' | 'info';
  public Display: boolean = true;
  public Button?: PopupButton = new PopupButton('Send', 'SendEmail');
  public AltButton?: PopupButton = new PopupButton('Cancel', 'Cancel');
  public communicationModel: CommunicationModel = new CommunicationModel();
}

export class CommunicationModel {
  public From: string = '';
  public To: string = '';
  public CC: string = '';
  public BCC: string = '';
  public Attachment!: string;
  //public List < FileModel > EmailAttachments : string;
  public Subject: string = '';
  public Body: string = '';
  public EmailAddress?: string;
  //public Template: string;
  //public ActiveCaseID: number;
  public AgentID!: number;
  public AttachmentsCSV!: string;
  public EmailFromAccountID!: number;
  public Guid!: string;
  public Type!: string;
  public SendDate!: string;
  public AgentFullName!: string;
  public RequiresValidation!: boolean;

}
export class PopupButton {
  public ButtonText?: string;  // Text for the action button
  public Result?: string;      // Action when the button is clicked
  constructor(ButtonText?: string, Result?: string) {
    this.ButtonText = ButtonText;
    this.Result = Result;
  }
}


export class File_ImageSetups {
  public EntityID!: number;
  public EntityType!: string;
  public MobImage!: string; //Mobile
  public MobID!: number;
  public MobMaxW!: number;
  public MobMaxH!: number;
  public MobFitScreen: boolean = false;
  public MobHide: boolean = false;
  public MobHImage!: string; //Mob horizontal 
  public MobHID!: number;
  public MobHMaxW!: number;
  public MobHMaxH!: number;
  public MobHFitScreen: boolean = false;
  public MobHHide: boolean = false;
  public TabImage!: string; //Tab
  public TabID!: number;
  public TabMaxW!: number;
  public TabMaxH!: number;
  public TabFitScreen: boolean = false;
  public TabHide: boolean = false;
  public TabHImage!: string;//Tab horizontal
  public TabHID!: number;
  public TabHMaxW!: number;
  public TabHMaxH!: number;
  public TabHFitScreen: boolean = false;
  public TabHHide: boolean = false;
  public DeskImage!: string; //desktop
  public DeskID!: number;
  public DeskMaxW!: number;
  public DeskMaxH!: number;
  public DeskFitScreen: boolean = false;
  public DeskHide: boolean = false;
  public DeskWImage!: string; //DeskW
  public DeskWID!: number;
  public DeskWMaxW!: number;
  public DeskWMaxH!: number;
  public DeskWFitScreen: boolean = false;
  public DeskWHide: boolean = false;
  public MobUploadW!: number;
  public MobHUploadW!: number;
  public TabUploadW!: number;
  public TabHUploadW!: number;
  public DeskUploadW!: number;
  public DeskWUploadW!: number;
  public MobUploadH!: number;
  public MobHUploadH!: number;
  public TabUploadH!: number;
  public TabHUploadH!: number;
  public DeskUploadH!: number;
  public DeskWUploadH!: number;
  public MobHideMap: boolean = true;
  public MobHHideMap: boolean = true;
  public TabHideMap: boolean = true;
  public TabHHideMap: boolean = true;
  public DeskHideMap: boolean = true;
  public DeskWHideMap: boolean = true;
  public MobHasOver: boolean = false;
  public MobHHasOver: boolean = false;
  public TabHasOver: boolean = false;
  public TabHHasOver: boolean = false;
  public DeskHasOver: boolean = false;
  public DeskWHasOver: boolean = false;
  public MobOverCol!: string;
  public MobHOverCol!: string;
  public TabOverCol!: string;
  public TabHOverCol!: string;
  public DeskOverCol!: string;
  public DeskWOverCol!: string;
  public MobOverOp!: string;
  public MobHOverOp!: string;
  public TabOverOp!: string;
  public TabHOverOp!: string;
  public DeskOverOp!: string;
  public DeskWOverOp!: string;

}


export class StockDelivery {
  UserID!: number;
  SysproCompanyID!: number;
  StockID!: number;
  Status!: string;
  StatusReason!: string;
  AcceptedDate!: string;
  EstimatedDeliveryDate!: string;
  EstimatedDeliveryTime!: string;
  Function!: string;
  public StockDetails!: Array<StockDeliveryDetails>;
}

export class StockDeliveryDetails {
  StockDetailsID!: number;
  StockCode!: string;
  WareHouse!: string;
  Bin!: string;
  ActualQuantity!: number;
  EstimatedQuantity!: number;
  QuantityVarianceReason!: string;
  Description!: string;
  UOM!: string;
  StockUnitsPerUOM!: number;
  IsActive: boolean = true;
}

export class StockParameters {
  sysproCompanyID!: number;
  supplier!: string;
}

// Scheduler begin
export class Resources {
  id!: number;
  name!: string;
  eventColor?: string;
}

export class Events {
  id!: number;
  resourceId!: number;
  name!: string;
  startDate!: string;
  endDate!: string;
}
//scheduler end

//Services
export class SP_Type {
  Guid!: string;
  SPType!: string;
  Active!: boolean;
}
export class ServiceProvider {
  ID!: number;
  Guid!: string;
  SPTypeGuid!: string;
  Active!: boolean;
  Name!: string;
  Description!: string;
  Duration!: number;
  Notes!: string;
  Selected!: boolean;
  ForInProgress!: boolean;
  ForNewPatient!: boolean;
  ForOldPatient!: boolean;
  ForAllPatient!: boolean;
}

export class SPType_ServiceProvider {
  Guid!: string;
  SPType!: string;
  Active!: boolean;
  Services!: ServiceProvider[];
}
//Services End
export class Lookups {
  public ID!: number;
  public Guid!: string;
  public Type!: string;
  public Description!: string;
  public Active!: boolean;
}
//Patient
export class Patient {
  ID!: number;
  Guid!: string;
  Active!: boolean;
  ParentMemberGuid!: string;
  Title!: string;
  Name!: string;
  Surname!: string;
  FullName!: string
  Status!: string;
  Gender!: number;
  GenderType!: string;
  Email!: string;
  Cellphone!: string;
  IDNumber!: string;
  Notes!: string;
  AdditionalNotes!: string;
  ContactMethod!: string;
  MemberType!: string;
  //Group!: string;
  //ConfirmationMessageType!: string;
  Selected!: boolean;
}
//Patient End
//Staff
export class Staff {
  ID!: number;
  Guid!: string;
  Active!: boolean;
  Password!: string;
  UserType!: number;
  StartDate!: Date
  EndDate!: Date;
  IncomeTaxNumber!: string
  IDNumber!: string;
  Title!: string;
  Name!: string;
  Surname!: string;
  FullName!: string;
  ProvinceID!: number ;
  BranchID!: number | null;
  RoleID!: number;
  Department!: string;
  Gender!: string;
  Email!: string;
  Cellphone!: string;
  MedicalAid!: string;
  MedicalAidNumber!: string;
  EmergencyContact!: string;
  EmergencyContactRelation!: string;
  EmergencyContactCellphone!: number;
  AgentID!: number;
  Selected!: boolean;
  Reason!: string;
}
//Staff End
//Appointmant
export class Appointment {
  AppointmentID!: number;
  BranchID!: number;
  BranchName!: string;

  //rework
  AudiologistID!: number;
  StaffMemberID!: number;
  StartDate!: string;
  StartTime!: string;
  EndDate!: string;
  EndTime!: string;
  LocationID?: number;
  PatientID!: number;
  AppointmentNotes!: string;
  ConfirmationCellphone!: string;
  SendConfirmation!: string;
  Duration!: number;
  ServiceProviderID!: number;
  SPType!: string;
  IsEmployeeMeeting!: boolean;
}

export class AppointmentSummary {
  ID!: number;
  AppointmentID!: number;
  AppointmentName!: string;
  AppointmentNotes!: string;
  StartDate!: string;
  StartTime!: string;
  EndDate!: string;
  EndTime!: string;
  CreateByAgentID!: number;
  CreatedBy!: string;
  AllocatedUserID!: number;
  DoctorName!: string;
  BranchID!: number;
  BranchName!: string;
  LocationID!: number;
  Location!: string;
  PatientID!: number;
  PatientGuid!: string;
  PatientIDNumber!: string;
  PatientTitle!: string;
  PatientName!: string;
  PatientStatus!: string;
  PatientGender!: string;
  PatientEmail!: string;
  PatientCellphone!: string;
  PatientNotes!: string;
  PatientAlternativeNotes!: string;
  ServiceProviderID!: number;
  ServiceType!: string;
  ServiceName!: string;
  ServiceDescription!: string;
  IsEmployeeMeeting!: boolean;
  IsSeries!: boolean;
}

export class AppointmentHistory {
  AppointmentID!: number;
  BranchID!: number;
  AgentID!: number;
  Details!: string;
  Result!: string;
  AppointmentOutcome!: string;
  Activity!: string;

  date!: string;
  name!: string;
  details!: string;
  branch!: string;
  result!: string;
  result2!: string;
  activity!: string;
}

export class AdministrationCheckout {
  ID!: number
  AppointmentID!: number;
  Guid!: string;
  CheckoutStaffID!: string;
  CheckoutAgentID!: number;
  CaseSubID!: number;
  InvoiceNumber!: string;
  NoCharge!: string;
  CheckoutStatus!: string;
  PatientStatus!: string;
  HearingOutCome!: string;
  FinalHAOutCome!: string;
  FutureAction!: string;
  PatientID!: number;
  PatientGuid!: string;
  ModifySeries!: boolean;
}

export class AdministrationAppointment {
  ID!: number;
  BranchID!: number;
  StaffMemberID!: number;
  StaffMemberGuid!: string;
  Type!: string;
  Duration!: number;
  DateFron!: string;
  DateTo!: string;
  StartTime!: string;
  EndTime!: string;
  DayOption!: string;
}

export class AppointmentType {
  ID!: number;
  Name!: string;
}

export class Users {
  ID!: number;
  Guid!: string;
  Name!: string;
  Surname!: string;
}

export class Province {
  ID!: number;
  Guid!: string;
  Type!: string;
}

export class Branch {
  ID!: number;
  BranchName!: string;
}

export class Roles {
  ID!: number;
  Guid!: string;
  RoleName!: string;
}

export class MeetingAppointment {
  StaffMemberID!: number;
  StartDate!: string;
  StartTime!: string;
  EndDate!: string;
  EndTime!: string;
  LocationID!: number;
  ServiceProviderID!: number;
  SPType!: string;
  BranchID!: number;
}

export class Days {
  Week: { [key: string]: boolean } = {
    sunday: true,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true
  };
}

export class ServiceAreas {
  ID!: number;
  BranchID!: number;
  Guid!: string;
  ServiceAreaName!: string;
  Active!: Boolean;
}
//Appointment END


export class ReportRequest {
  dateFrom!: string;
  dateTo!: string;
  branchID!: number;
  staffID!: number;
  patientID!: number;
  serviceID!: number;
  appointmentID!: number;
  appointmentType!: string;
  appointmentStatus!: string;
  appointmentOutcome!: string;
  patientStatus!: string;

}

export class ActivityHistory {
  Guid!: string;
  Active!: boolean;
  AgentGuid!: string;
  AgentID!: number;
  AgentName!: string;
  UserID!: number;
  StaffName!: string;
  MemberID!: number;
  PatientName!: string;
  BranchID!: number;
  BranchName!: string;
  ActionDate!: string;
  Action!: string;
  ActionDetails!: string;
  ActionResult!: string;
  ActionResult2!: string;
}

export class ReportHistory {
  ID!: number;
  Guid!: string;
  FileName!: string;
  FilePath!: string;
  StaffName!: string;
  Action!: string;
  ActionDate!: string;
  ActionTime!: string;
}

export class MemberSurvey
{
  public ID!: number;
  public MemberID!: number;
  public QuestionsID!: number;
  public GeneratedGuid!: string;
  public QuestionField1!: string;
  public QuestionField2!: string;
  public QuestionField3!: string;
  public AnswerField1!: string;
  public AnswerField2!: string;
  public AnswerField3!: string;
}

export class Ratings {
  ratingOptions: boolean[] = [false, false, false, false, false];
  answer: number = 0;

}
